module.exports = __webpack_public_path__ + "img/DAVID_CANNON_18-rs.35f2840f.jpg";